import { API_URL } from "../../config";
import API from "../../api/Routes";
import ApiServices from "../../services/Api.services";
import ACTION from "../../actions";
import { showErrorToast, showSuccessToast } from "../../utils/Functions";
import { getSkillSetList } from "../Profile/actions";

// export const jobListing = (payload) => async (dispatch) => {
//   try {
//     await ApiServices.postApi(API_URL + API.JOB_LISTING, payload).then(
//       (response) => {
//         dispatch({
//           type: ACTION.JOB_LISTING,
//           payload: response.data,
//         });
//       }
//     );
//   } catch (error) {
//     showErrorToast(error);
//   }
// };

export const jobListing = () => async (dispatch) => {
  try {
    await ApiServices.getApi(API_URL + API.JOB_LISTING).then((response) => {
      dispatch({
        type: ACTION.JOB_LISTING,
        payload: response.data.data,
      });
      return response;
    });
  } catch (error) {
    showErrorToast(error);
  }
};

export const applyJob = (payload) => async (dispatch) => {
  try {
    const response = await ApiServices.postApi(
      API_URL + API.APPLY_JOB,
      payload
    );
    if (response?.status === 1) {
      showSuccessToast(response?.message);
      await dispatch(jobListing());
      return response;
    } else {
      showErrorToast(response.message);
    }
  } catch (error) {
    showErrorToast(error.message);
  }
};

export const getJobDetails = (payload) => async (dispatch) => {
  try {
    await ApiServices.postApi(API_URL + API.GET_JOB_DETAILS, payload).then(
      (response) => {
        if (response?.data?.status === 1 && response?.data?.data) {
          dispatch({
            type: ACTION.JOB_DETAILS,
            payload: response.data.data,
          });
        } else {
          console.error(
            "getJobDetails failed for payload:",
            payload,
            "response:",
            response?.data
          );
          showErrorToast(
            response?.data?.message || "Unable to load this job's details."
          );
        }
        return response;
      }
    );
  } catch (error) {
    showErrorToast(error?.message || error);
  }
};
export const addSkillsMaster = (payload) => async (dispatch) => {
  try {
    await ApiServices.postApi(API_URL + API.ADD_SKILL_MASTER, payload).then(
      (response) => {
        dispatch({
          type: ACTION.ADD_SKILLS_MASTER,
          masterSkills: response.data.data,
        });
        dispatch(getSkillSetList());
        return response;
      }
    );
  } catch (error) {
    showErrorToast(error);
  }
};
